export const Navigation = () => {
  let body = $('body');
  let html = $('html');
  let headerWrap = $('.header');

  const openNavigation = () => {
    body.toggleClass('opened');
    html.toggleClass('opened');
  };

  $('.js-toggle-navigation').on('click', () => {
    const windowHeight = window.innerHeight;
    const offsetHeaderWrap = headerWrap.offset().top;
    const heightHeaderWrap = headerWrap.height();
    const positionHeader = offsetHeaderWrap - $(window).scrollTop();
    const navHeight = windowHeight - positionHeader - heightHeaderWrap;
    openNavigation();
    $('.js-menu')
      .toggleClass('menu-opened')
      .css('height', $('div').is('.menu-opened') ? navHeight : 0);

    if (body.hasClass('opened')) {
      $('html, body')
        .off('touchstart touchmove')
        .on('touchstart touchmove', function (e) {
          e.preventDefault();
        });
    }
  });

  const stickyNav = () => {
    let offsetTop = headerWrap.offset().top;

    if (offsetTop > 0) {
      headerWrap.addClass('sticky');
    } else if (offsetTop === 0) {
      headerWrap.removeClass('sticky');
    }
  };

  setTimeout(stickyNav(), 100);
  $(window).on('scroll', () => stickyNav());

  $(window).bind("resize", function () {
    if ($(this).width() > 991) {
      $('body').removeClass('opened');
      $('html').removeClass('opened');
      $('.js-menu').removeClass('menu-opened').removeAttr('style');
    }
  }).trigger('resize');

};
